import {style, keyframes} from 'typestyle'

export const WKloadMoreWrap = style({
    display: 'block',
    textAlign: 'center',
    fontSize: 50,
    position: 'fixed',
    zIndex: 99,
    top: '35%',
    width: '100%',
    maxWidth: 480,
    paddingTop: 20
})

const Loading = keyframes({
    '0%' : { transform: 'rotate3d(0, 0, 1, 0deg)' },
    '100%' : { transform: 'rotate3d(0, 0, 1, 360deg)'}
})

export const WKloadMore = style({
    width: 35,
    height: 35,
    display: 'inline-block',
    verticalAlign: 'middle',
    animationName: Loading,
    animationDuration: '1s',
    animationIterationCount: 'infinite',
    background: `rgba(216, 0, 0, 0) url('https://static-cos.lycheer.net/picture/8173011_cb7d85c98815780ec40414520416eed1.jpg') no-repeat`,
    backgroundSize: '100%'
})



// WEBPACK FOOTER //
// ./src/components/Loading/LoadingStyle.ts